import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { Bot } from "../../../../models/bot";
import { Role } from "../../../../models/role";
import { BotControllerService } from "../../../../services/role-controller/bot-controller.service";
import { RoleControllerService } from "../../../../services/role-controller/role-controller.service";
import { ServiceControllerService } from "../../../../services/service-controller/service-controller.service";
import { TranslatedBaseError } from "../../TranslatedBaseError";
import { RoleBotManageComponent } from "../../bots/components/manage/role-bot-manage.component";
import { FormControllerService } from "../../../../services/form-controller/form-controller.service";

@Component({
    selector: "app-external-links",
    templateUrl: "./external-links.component.html",
    providers: [BotControllerService, RoleControllerService, ServiceControllerService, FormControllerService]
})
export class ExternalLinksComponent extends TranslatedBaseError implements OnInit {

    public bots: Bot[] = [];
    public serviceId: string;
    public isDrawerClosed: boolean = true;
    public selectedBot: Bot = new Bot();
    public searchValue: string = "";
    public customFilter: any = {};

    public allRoles: Role[] = [];
    public allFields: any[] = [];

    @ViewChild(RoleBotManageComponent) public roleBotManage: RoleBotManageComponent;

    constructor(
        private route: ActivatedRoute,
        private roleController: RoleControllerService,
        private formControllerService: FormControllerService,
        private botController: BotControllerService,
        toastr: ToastrService,
        public translateService: TranslateService
    ) {
        super(toastr, translateService);
    }

    public ngOnInit() {
        console.log("ExternalLinksComponent ngOnInit");
        this.route.params.subscribe((params) => {
            console.log("ExternalLinksComponent params", params);
            this.serviceId = params.serviceId;
            if (this.serviceId) {
                this.loadBots();
            }
        });
    }

    public loadBots() {
        this.botController.getServiceBots(this.serviceId).subscribe(
            (data) => {
                this.bots = data.filter(b => b.botType === "link");
                this.getRolesList();
                this.getActionsList();
            },
            (error) => this.showErrorMessage(error)
        );
    }

    public createLink(event: any) {
        this.selectedBot = new Bot();
        this.selectedBot.botType = "link";
        this.selectedBot.externalTarget = true;
        this.isDrawerClosed = false;
    }

    public editLink(bot: Bot) {
        this.selectedBot = bot;
        this.isDrawerClosed = false;
    }

    public deleteLink(bot: Bot) {
        this.botController.deleteBot(bot.id).subscribe(
            () => {
                this.responseSuccessful("Link deleted!");
                this.loadBots();
            },
            (error) => this.showErrorMessage(error)
        );
    }

    public getRolesList() {
        this.roleController.getRolesDetailedList(this.serviceId).subscribe(
        (data) => {
            this.allRoles = data;
            this.updateRoleCounter();
        },
        );
    }

    public getActionsList() {
        this.formControllerService.getFlattenFormFieldsWithAdds(this.serviceId, false, true, false, false, false, true).subscribe(
        (data) => {
            this.allFields = data;
            this.updateActionCounter();
        },
        );
    }

    public updateActionCounter() {
        this.bots.forEach((b) => {
            b.counterActions = this.allFields.filter((r) => {
                return r.actions && r.actions.filter((a) => {
                return a.id === b.id;
                }).length;
            });
        });
    }

    public updateRoleCounter() {
        this.bots.forEach((b) => {
            b.counterRoles = this.allRoles.filter((r) => {
                return r.botRoleBots && r.botRoleBots.actions && r.botRoleBots.actions.find((a) => {
                return a.bots.find((ab) => {
                    return ab.id === b.id;
                });
                });
            });
        });
    }

    public closeDrawer() {
        this.isDrawerClosed = true;
        this.selectedBot = new Bot();
    }

    public onBotSaved() {
        this.loadBots();
        this.closeDrawer();
    }

    public saveLink() {
        if (this.selectedBot.id) {
            this.roleBotManage.saveBot();
        } else {
            this.roleBotManage.addNewBot();
        }
        // We can close the drawer here if we want, or wait for success.
        // RoleBotManage emits 'modalAddedEvent' or 'changedData' on success.
        // We handle those in onBotSaved().
        // Let's rely on those events to reload the list.
        // But we might want to close the drawer on success.
        // For now, let's just trigger the save.
    }

    public searchTextChanged(value: string) {
        this.searchValue = value;
        this.customFilter.name = value;
    }

    public resetSearch() {
        this.searchValue = "";
        this.customFilter.name = "";
    }
}
